import { Module } from 'vuex'
import { CreditState, state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState } from '@/app/common/types/root-state.type'

export const creditStore: Module<CreditState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
